import concatWith from 'callbag-concat-with';
import map from 'callbag-map';
import msElapsed from 'callbag-ms-elapsed';
import takeWhile from 'callbag-take-while';

function durationProgress(ms) {
  return concatWith(1)(takeWhile(function (progress) {
    return progress <= 1;
  })(map(function (elapsed) {
    return elapsed / ms;
  })(msElapsed)));
}

export default durationProgress;



//////////////////
// WEBPACK FOOTER
// ./node_modules/callbag-duration-progress/dist/callbag-duration-progress.esm.js
// module id = 625
// module chunks = 0